import React from "react";
import {getTranslation} from "../translations/translationUtils";
import {removeHtmlStyles, replaceBrTextWithHtmlTags} from "../utils/stringUtils";
import {PropTypes} from "prop-types";
import {connect} from "react-redux";

class LocationAndTimes extends React.Component {

    render() {
    // remove whereAndWhen once hub changes are done
    
        const locationInformation = this.props.whereAndWhen?.locationInfo ? getTranslation(this.props.whereAndWhen.locationInfo) : this.props.whereAndWhen?.locationInformation;
    
    
        return (
            <div>
                {this.props.whereAndWhen && locationInformation &&
                    <>
                        <h3>{this.context.t("location")}</h3>
                        <p dangerouslySetInnerHTML={{__html: replaceBrTextWithHtmlTags(locationInformation)}} />
                    </>
                }
                {this.props.item && this.props.item.times.defaultPlainValue !== "" &&
                    <>
                        <h3>{this.context.t("location")}</h3>
                        <p>{getTranslation(this.props.item.location)}</p>
                    </>
                }
                {this.props.whereAndWhen && this.props.whereAndWhen.timeInformation &&
                    <>
                        <h3>{this.context.t("times")}</h3>
                        <p dangerouslySetInnerHTML={{__html: replaceBrTextWithHtmlTags(this.props.whereAndWhen.timeInformation)}} />
                    </>
                }
                {this.props.item && this.props.item.times.defaultPlainValue !== "" &&
                    <>
                        <h3>{this.context.t("times")}</h3>
                        <p dangerouslySetInnerHTML={{ __html: removeHtmlStyles(getTranslation(this.props.item.times)) }} />
                    </>
                }
            </div>
        );
    }
}


LocationAndTimes.contextTypes = {
    t: PropTypes.func.isRequired
};

const mapStateToProps = state => {
    // lang used to trigger rerender in new language when changed
    return { lang: state.i18nState.lang };
};

export default connect(mapStateToProps, null)(LocationAndTimes);
